export const PartnerProgramIcon = () => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none">
          <path fill="#F2F2F2" fillRule="evenodd" d="M3.093 3.801a3.093 3.093 0 1 1 0 6.187 3.093 3.093 0 0 1 0-6.187Zm3.379 4.74c-.098.2-.214.39-.344.569l2.453 1.152c.068-.213.163-.414.28-.598L6.472 8.54Zm-.47-4.024c.14.17.265.354.373.547l2.462-1.768a2.59 2.59 0 0 1-.274-.617l-2.56 1.838ZM11.06 0a1.94 1.94 0 1 1 0 3.88 1.94 1.94 0 0 1 0-3.88Zm0 9.12a1.94 1.94 0 1 1 0 3.88 1.94 1.94 0 0 1 0-3.88Z" clipRule="evenodd"/>
      </svg>
  )
}